import React from "react"
import PropTypes from "prop-types"
import scrollTo from "scroll-to-element"

export default class Sidebar extends React.Component {

  static propTypes = {
    specSelectors: PropTypes.object.isRequired,
  };

  onScroll = (tag) => {
    scrollTo(`#${tag}`, {
      offset: -5
    })
  }

  evaluateGetMethod = (path) => {
    if ((/.*\/{.*?/).test(path)) {
      return true
    } else {
      return false
    }
  }

  evaluatePostMethod = (path) => {
    if((/bulk/g).test(path)) {
      return true
    } else {
      return false
    }
  }

  renderBasicsOfListSidebar(isInternal) {
    if (!isInternal) {
      return (<li><a onClick={ () => this.onScroll('the_basics_of_list') }>The Basics of LIST</a></li>);
    }
    return null;
  }

  renderOAuthDemoSidebar(isInternal) {
    if (!isInternal) {
      return (<li><a href="/oauthindex.html" target="_blank">OAuth Demo</a></li>);
    }
    return null;
  }

  render() {

    let {
      specSelectors,
      getConfigs
    } = this.props

    let taggedOps = specSelectors.taggedOperations()

    const {
      isInternal
    } = getConfigs()

    return (
      <div className="thr-sidebar">
          <h3 className="top-padding">Getting Started</h3>
          <ul>
              <li><a onClick={ () => this.onScroll('welcome') }>Welcome</a></li>
              <li><a onClick={ () => this.onScroll('security') }>Security</a></li>
              {this.renderBasicsOfListSidebar(isInternal)}
          </ul>

          <h3>Resources</h3>
          <ul>
            {
              taggedOps.map( (tagObj, tag) => {
                let operations = tagObj.get("operations")
                return (
                  <div key={tag}>
                    <li>
                      <a onClick={ () => this.onScroll(tag) }>{ tag }</a>
                    </li>
                    <ul className="api-actions">
                      {
                        operations.map( op => {
                          const key_id = op.get("id", "")
                          const method = op.get("method", "")
                          const path = op.get("path", "")
                          const myOp = op.get("operation","")
                          const summary = myOp ? myOp.get("summary", "").split(" ")[0] : ""
                          const methodType = method === 'get' ? (this.evaluateGetMethod(path) === true ? 'one' : 'all') : (method === 'post' ? (this.evaluatePostMethod(path) === true ? 'bulk' : null) : null);
                          const methodLink = methodType ? tag + '-' + method.toUpperCase() + '-' + methodType.toUpperCase() : tag + '-' + method.toUpperCase()
                          const methodLabel = summary ? (summary + ' (' + method.toUpperCase() + ')') : method.toUpperCase()
                          return (
                            <li key={key_id}>
                              <a onClick={ () => this.onScroll(methodLink)}>{ methodLabel }</a>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                )
              })
            }
          </ul>

          <h3>Help / Support</h3>
          <ul>
              <li><a href="mailto:developersupport@thinkhr.com">Developer Support</a></li>
              {this.renderOAuthDemoSidebar(isInternal)}
          </ul>
      </div>
    )
  }
}

Sidebar.propTypes = {
  specSelectors: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/sidebar.jsx